import React, { useEffect, useState } from "react";
import style from "./Drawer.module.scss";
import { IconClosedSurvey } from "../../Icons/index";
import { Spinner } from "components";

function Drawer(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [isClose, setIsClose] = useState(false);
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState(true);
  const [msg, setMsg] = useState("");

  let timer;
  useEffect(() => {
    if (props.show) {
      clear();
      setIsOpen(props.show);
    }
    return () => {
      console.log("unmounted");
      clear();
    };
  }, [props.show]);

useEffect(()=>{
  if(isClose){
    setPreview(true)
  }
},[isClose])

useEffect(() => {
  if(props.forceClose) { 
    if(props.forceClose === true){ 
      animation();
  }}
},[props.forceClose])


  const handleClose = () => {
    animation();
  };

  const clear = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null; // Clear the timeoutId
    }
  };

  const animation = () => {
    clear();
    setIsClose(true);
    //change timout time according to animation timming
    timer = setTimeout(() => {
      setIsOpen(false);
      props.setShow(false);
      setIsClose(false);
    }, 250);
  };
  const propedChildren = React.Children.map(props.children, (child) =>
    React.cloneElement(child, { setLoading ,setMsg,setPreview})
  );

  return (
    <>
      {isOpen ? (
        <div className={style.mainWrap}>
          <div
            className={style.drawerWrap}
            id={isClose ? style.closeWrap : null}
          >
            <button
              className={style.btnClose}
              onClick={() => {
                handleClose();
              }}
            >
              <IconClosedSurvey />
            </button>
            {!preview?<p>{msg}</p>:propedChildren}
          </div>
        </div>
      ) : null}
    </>
  );
}

export default Drawer;
